<div class="fixed bottom-5 right-3 z-50 group" id="chatbot-modal" [ngClass]="{ hidden: !shouldDisplay }">
  <!-- Floating Chatbot Icon -->
  <div [ngClass]="{ hidden: !modalHidden }">
    <button class="float-icon"
      (click)="modalHidden = !modalHidden; sendChatbotOpenEvent()">
    </button>

    <!-- Floating Tooltip with pure CSS. External Libraries have difficulty with dynamic text -->
    <div [ngClass] = "{invisible: !showTooltip}"
        class="absolute right-full top-[45%] transform -translate-y-1/2
                mb-2 me-2 w-[19rem] sm:w-80 px-4 py-2
                text-sm font-medium transition-opacity duration-300
                rounded-lg shadow-xs bg-[#FFDCBF] ease-in-out">
      {{ "chatbot.chatTooltip" | referrerTranslate | async }} 🍽️✨

      <!-- Tooltip Arrow -->
      <span class="absolute left-full top-1/2 -translate-y-1/2
            border-y-8 border-y-transparent
            border-l-8 border-l-[#FFDCBF]">
      </span>
    </div>
  </div>

  <div [ngClass]="{ hidden: modalHidden }">
    <div class="flex items-center justify-center">
      <div class="fixed inset-0 bg-[#F7F0EB] rounded-xl shadow-lg flex flex-col
                  overflow-y-auto md:inset-auto md:bottom-4 md:right-4 md:w-[27rem] md:h-[750px]">

        <!-- Close Arrow button -->
        <div class="position-relative top-8 left-4"></div>

        <!-- Chatbot Main Message Body -->
        <div class="px-6 pt-4 text-sm text-gray-700 select-none">
          <div class="gap-2 mb-4">
            <span class="flex">
              <span class="content-center p-2" (click)="modalHidden = !modalHidden">
                <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.4056 6.5896L8.2792 2.8032C8.51894 2.56391 8.6585 2.24227
                      8.6695 1.90372C8.68049 1.56517 8.5621 1.23515 8.3384 0.980804C8.23089
                       0.857628 8.09926 0.757818 7.95163 0.687549C7.80401 0.61728 7.64354
                       0.578045 7.48015 0.572271C7.31676 0.566497 7.15392 0.594307 7.0017
                       0.653981C6.84949 0.713655 6.71114 0.803923 6.5952 0.919204L1.224
                       6.1696L1.1936 6.2C0.380801 7.028 0.363201 8.3888 1.1552 9.24L6.5552
                       15.0384C7.0296 15.5488 7.8112 15.56 8.2992 15.0624C8.7872 14.5664 8.7968
                       13.7496 8.3216 13.2392L4.532 9.1696H14.196C14.8776 9.1696 15.4296 8.592
                       15.4296 7.8792C15.4296 7.1672 14.8776 6.5896 14.196 6.5896H4.4056Z"
                    fill="#D6C3B5" />
                </svg>
              </span>

              <!-- TakeMe AI Icon -->
              <span class="m-auto">
                <img
                  ngSrc="../../../assets/images/chatbot_takeme_logo.png"
                  alt="TakeMe"
                  class="h-[40px] w-[57px] md:h-[60px] md:w-[85px]"
                  height="80"
                  width="114" />
              </span>
            </span>
          </div>

          <!--Default AI Message-->

          @if (!messages.length) {
          <div>
            <p class="mb-2">{{ "chatbot.intro" | referrerTranslate | async }}</p>
            <p class="mb-2">{{ "chatbot.introBody" | transloco }}</p>
            <p class="italic text-[#971E1A]">{{ "chatbot.introExample" | transloco }}</p>
          </div>
          }

          <! -- All Messages -->
          <div class="flex flex-col gap-2">
            @for (message of messages; track $index; let last = $last) { @switch (message.resultType) {
              @case ("user_text") {
            <ng-container *ngTemplateOutlet="userMessage; context: { $implicit: message }"></ng-container>
            } @case ("text") {
            <ng-container *ngTemplateOutlet="aiTextMessage; context: { $implicit: message }"></ng-container>
            } @case ("shopRecommendations") {
            <ng-container *ngTemplateOutlet="aiShopRecommendations; context: { $implicit: message, isLast: last }"></ng-container>
            } } }
          </div>

          <ng-template #userMessage let-message>
            <div class="bg-[#FFE3D0] px-3 py-2 rounded-lg">
              <span class="ms-1">
                {{ message?.["message"] }}
              </span>
            </div>
          </ng-template>

          <ng-template #aiTextMessage let-message>
            <div class="flex items-center gap-3 px-4 py-1 rounded-lg">
              <!-- TakeMe logo -->
              <img
                ngSrc="../../../assets/images/chatbot_takeme_logo.png"
                alt="TakeMe"
                class="h-[40px] w-[57px]"
                height="80"
                width="114" />

              <!-- Message text -->
              <p class="text-sm md:text-base text-gray-900 leading-snug m-0">
                {{ message?.message }}
              </p>
            </div>
          </ng-template>

          <ng-template #aiShopRecommendations let-message let-isLast="isLast">
            @if (message?.["shops"]?.length) {
            <div>
              <div class="flex gap-4 overflow-auto overflow-x-scroll pb-4">
                @for (shop of message["shops"]; track $index) {
                <div>
                  <app-chat-featured-shop [shop]="shop"></app-chat-featured-shop>
                </div>
                }
              </div>
            </div>

            @if (isLast) {
              @if (showIsHelpful) {
                <ng-container *ngTemplateOutlet="isHelpful"></ng-container>
              }
              <ng-container *ngTemplateOutlet="followUpActions; context: { $implicit: message }"></ng-container>
             }
            }
          </ng-template>

          <ng-template #followUpActions let-interact>
            @if (interact | isActionable) {
            <div class="flex justify-end gap-2 px-1 py-1">
              @for (action of interact | toActionable; track $index) {
                <!-- Note that toActionable is enforcing 2 buttons limit -->
                  <button (click)="submitButtonInteractRequest(action.type)"
                          [disabled]="isLoading"
                    class="bg-[#13536D] text-white px-2 py-2 border-2 border-[#002B3A] rounded-lg font-medium shadow hover:bg-[#167193] transition duration-300">
                    {{ INTERACTION_TYPE_LABELS[action.type] | transloco }}
                  </button>
              }
            </div>
            }
          </ng-template>

          <ng-template #isHelpful>
            <div class="text-[#A87A70] font-semibold mt-1 text-center text-md p-2 flex items-center gap-3">
              Was this helpful? 😊

              <div
                class="flex items-center justify-center w-[102px] h-[48px] rounded-[8px] border border-[#F2D7C5] bg-white shadow-sm hover:cursor-pointer">
                <!-- Thumbs Up -->
                <div class="flex flex-row">
                  <span class="p-1 hover:scale-150 transition-transform duration-200" (click)="clickIsHelpful(true);$event.stopPropagation()">
                    <img ngSrc="../../../assets/images/chat_thumbs_up.png" alt="thumbs up" height="15" width="15" />
                  </span>

                  <!-- Divider -->
                  <div class="border-solid border-[1px] border-[#F2D7C5] ms-3 me-3"></div>

                  <span
                    class="p-1 hover:rounded-full hover:scale-150 transition-transform duration-200"
                    (click)="clickIsHelpful(false); $event.stopPropagation()">
                    <img ngSrc="../../../assets/images/chat_thumbs_down.png" alt="thumbs down" height="15" width="15" />
                  </span>
                </div>
              </div>
            </div>
          </ng-template>

          <!-- Loading Icon -->
          @if (isLoading) {
          <div class="flex gap-1 items-center mt-2">
            <img
              ngSrc="../../../assets/images/chatbot_takeme_logo.png"
              alt="TakeMe"
              class="h-[40px] w-[57px]"
              height="80"
              width="114" />

            <div class="w-2 h-2 rounded-full bg-[#373131] animate-bounce [animation-delay:0s]"></div>
            <div class="w-2 h-2 rounded-full bg-[#373131] animate-bounce [animation-delay:0.2s]"></div>
            <div class="w-2 h-2 rounded-full bg-[#373131] animate-bounce [animation-delay:0.4s]"></div>
          </div>
          }
        </div>
        <!-- Main Body end -->

        <div class="flex-1" #messageBodyEnd></div>

        <!-- Message Input Area -->
        <div class="p-4">
          <form
            (ngSubmit)="sendMessage()"
            class="flex items-center bg-white rounded-full px-4 py-2 shadow-inner focus-within:ring-2 focus-within:ring-gray-300 focus-within:ring-offset-2 transition">
            <input
              [formControl]="form.controls.userMessage"
              type="text"
              class="flex-1 outline-none border-none text-sm placeholder-gray-400 focus-within:ring-0"
              placeholder="{{ 'chatbot.placeholder' | transloco }}" />
            <button (click)="sendMessage()" class="ml-2" type="submit" [disabled]="isLoading">
              <span>
                <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <ellipse cx="16" cy="16.5" rx="16" ry="16.5" fill="#2E2927" />
                  <path
                    d="M15 23C15 23.5523 15.4477 24 16 24C16.5523 24 17 23.5523 17 23L15 23ZM16.7071 10.2929C16.3166 9.90237 15.6834
                    9.90237 15.2929 10.2929L8.92893 16.6569C8.53841 17.0474 8.53841 17.6805 8.92893 18.0711C9.31946 18.4616
                     9.95262 18.4616 10.3431 18.0711L16 12.4142L21.6569 18.0711C22.0474 18.4616 22.6805 18.4616 23.0711
                     18.0711C23.4616 17.6805 23.4616 17.0474 23.0711 16.6569L16.7071 10.2929ZM17 23L17 11L15 11L15 23L17 23Z"
                    fill="white" />
                </svg>
              </span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
